export const EMPLOYEES_TYPE = {
  seller: 'seller',
  rd: 'rd',
  worker: 'worker',
  super_worker: 'super-worker',
  storage_worker: 'storage-worker',
  admin: 'admin',
  ceo: 'ceo'
}

export const GENDERS = {
  guy: 'guy',
  girl: 'girl'
}

export const EMPLOYEE_TYPE_LABEL_I18N_KEY = {
  [EMPLOYEES_TYPE.seller]: 'employees.employees_salaries.sales',
  [EMPLOYEES_TYPE.rd]: 'employees.employees_salaries.rd'
}
